// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as MaintenanceScheduleActions from '../actions/maintenance-schedule.actions';
import { MaintenanceAlert, MaintenanceSchedule } from '@fc-core';
import { HttpErrorResponse } from '@angular/common/http';

export const maintenanceScheduleFeatureKey = 'maintenanceSchedule';

export interface State {
  schedules: MaintenanceSchedule[];
  tooltipSchedules: MaintenanceSchedule[];
  schedulesAlerts: MaintenanceAlert[];
  loading: boolean;
  error: HttpErrorResponse | null;
}

export const initialState: State = {
  schedules: [],
  tooltipSchedules: [],
  schedulesAlerts: [],
  loading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(
    MaintenanceScheduleActions.loadMaintenanceSchedulesSuccess,
    (state, action) => ({
      ...state,
      schedules: action.schedules,
    }),
  ),
  on(
    MaintenanceScheduleActions.loadTooltipMaintenanceSchedulesSuccess,
    (state, action) => ({
      ...state,
      tooltipSchedules: action.schedules,
    }),
  ),
  on(
    MaintenanceScheduleActions.cleanTooltipInfo,
    (state): State => ({
      ...state,
      tooltipSchedules: null,
    }),
  ),

  on(MaintenanceScheduleActions.updateMaintenanceSchedule, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),

  on(
    MaintenanceScheduleActions.updateMaintenanceScheduleSuccess,
    (state, action) => {
      return {
        ...state,
        schedules: [
          ...state.schedules.filter(
            (schedule) => schedule.id !== action.maintenanceSchedule.id,
          ),
          action.maintenanceSchedule,
        ],
        loading: false,
      };
    },
  ),
  on(MaintenanceScheduleActions.deleteMaintenanceSchedule, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(MaintenanceScheduleActions.maintenanceSchedulesError, (state, { err }) => {
    return {
      ...state,
      loading: false,
      error: err,
    };
  }),
  on(
    MaintenanceScheduleActions.deleteMaintenanceScheduleSuccess,
    (state, action) => {
      return {
        ...state,
        schedules: state.schedules.filter(
          (schedule) => schedule.id !== action.maintenanceSchedule.id,
        ),
        loading: false,
      };
    },
  ),
  on(
    MaintenanceScheduleActions.addMaintenanceSchedule,
    MaintenanceScheduleActions.closeMaintenanceSchedule,
    MaintenanceScheduleActions.updateMaintenanceScheduleAlert,
    (state): State => {
      return {
        ...state,
        loading: true,
        error: null,
      };
    },
  ),
  on(
    MaintenanceScheduleActions.addMaintenanceScheduleSuccess,
    (state, action) => {
      return {
        ...state,
        schedules: [...state.schedules, action.maintenanceSchedule],
        loading: false,
      };
    },
  ),
  on(MaintenanceScheduleActions.closeMaintenanceScheduleSuccess, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(
    MaintenanceScheduleActions.loadAllMaintenanceScheduleAlerts,
    (state): State => {
      return {
        ...state,
        schedulesAlerts: [],
        loading: true,
      };
    },
  ),
  on(
    MaintenanceScheduleActions.loadAllMaintenanceScheduleAlertsSuccess,
    (state, action) => {
      return {
        ...state,
        schedulesAlerts: action.alertList,
        loading: false,
      };
    },
  ),
  on(
    MaintenanceScheduleActions.updateMaintenanceScheduleAlertSuccess,
    (state, action) => {
      return {
        ...state,
        loading: false,
        schedulesAlerts: state.schedulesAlerts.map((alert) =>
          alert.id === action.updatedAlert.id ? action.updatedAlert : alert,
        ),
      };
    },
  ),
);

export const getTooltipSchedules = (state: State) => state.tooltipSchedules;
export const getSchedules = (state: State) => state.schedules;
export const getSchedulesAlerts = (state: State) => state.schedulesAlerts;
export const getSchedulesLoading = (state: State) => state.loading;
export const getScheduleError = (state: State) => state.error;
